module.exports = __webpack_public_path__ + "files/1789ff40f3fa60ec17bac14439b6cd17.png";